export {
  default as OpenPaymentsCategoryComponent,
  renderOpenPaymentsCategoryComponent,
} from './OpenPaymentsCategoryComponent';
export * from './config';
